import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface setMerchantTermsAndConditionsPdfFormInterface {
    pdfUrl: string
}

export const fetchMerchantTermsAndConditionsPdf = async (): Promise<{ pdfUrl: string }> => {
    const response = await baseAxios.get<{ pdfUrl: string }>('/api/serviceProviderConfiguration/merchantTermsAndConditions/pdf');

    return response.data;
};

export const setMerchantTermsAndConditionsPdf = async (form: setMerchantTermsAndConditionsPdfFormInterface): Promise<void> => {
    await baseAxios.post('/api/serviceProviderConfiguration/merchantTermsAndConditions/pdf', {
        pdfUrl: form.pdfUrl,
    });
};

export default (axios: AxiosInstance = baseAxios): { fetchMerchantTermsAndConditionsPdf: () => Promise<{ pdfUrl: string; }>; setMerchantTermsAndConditionsPdf: (form: setMerchantTermsAndConditionsPdfFormInterface) => Promise<void>; } => ({
    fetchMerchantTermsAndConditionsPdf: async (): Promise<{ pdfUrl: string }> => {
        const response = await axios.get<{ pdfUrl: string }>('/api/serviceProviderConfiguration/merchantTermsAndConditions/pdf');

        return response.data;
    },

    setMerchantTermsAndConditionsPdf: async (form: setMerchantTermsAndConditionsPdfFormInterface): Promise<void> => {
        await axios.post('/api/serviceProviderConfiguration/merchantTermsAndConditions/pdf', {
            pdfUrl: form.pdfUrl,
        });
    },
});
